module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "callback"
  }, [_vm._v(_vm._s(_vm.message))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d98fbf8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Callback.vue
// module id = 1393
// module chunks = 1